import script from "./PrintFormSuratPernyataanKebenaranDokumen.vue?vue&type=script&setup=true&lang=js"
export * from "./PrintFormSuratPernyataanKebenaranDokumen.vue?vue&type=script&setup=true&lang=js"

import "./PrintFormSuratPernyataanKebenaranDokumen.vue?vue&type=style&index=0&id=2724e09e&lang=css"

const __exports__ = script;

export default __exports__